import { useEffect } from "react";

const OTPBehaviour = ({ debugOtp, otpCreatedAt }) => {

  useEffect(() => {

    /* ===============================
       OTP BOX INITIALIZATION
    =============================== */

    const inputs = document.querySelectorAll(".otp-box");
    const hiddenInput = document.getElementById("id_Enter_OTP");
    const otpMessageContainer = document.querySelector(".flash-container");

    function showOTPMessage(msg) {
      if (!otpMessageContainer) return;

      const existingMsg = otpMessageContainer.querySelector(".otp-success");
      if (existingMsg) existingMsg.remove();

      const msgEl = document.createElement("p");
      msgEl.className = "flash-message otp-success";
      msgEl.style.color = "#03AB77";
      msgEl.style.fontSize = "13px";
      msgEl.style.fontWeight = "500";
      msgEl.style.display = "flex";
      msgEl.style.alignItems = "center";
      msgEl.style.gap = "6px";

      msgEl.innerHTML = msg;
      otpMessageContainer.appendChild(msgEl);
    }

    /* Default dash placeholder */
    inputs.forEach(input => {
      if (!input.value) {
        input.value = "";
        input.classList.add("placeholder-dash");
      }
    });

    /* OTP INPUT LOGIC */
    inputs.forEach((input, idx) => {

      input.addEventListener("focus", () => {
        if (input.value === "-") {
          input.value = "";
          input.classList.remove("placeholder-dash");
        }
      });

      input.addEventListener("blur", () => {
        if (input.value === "") {
          input.value = "-";
          input.classList.add("placeholder-dash");
        }
      });

      input.addEventListener("input", () => {

        if (input.value === "-") input.value = "";

        /* Auto move focus */
        if (input.value && idx < inputs.length - 1) {
          inputs[idx + 1].focus();
        }

        /* Update hidden OTP */
        hiddenInput.value = Array.from(inputs)
          .map(i => (i.value === "-" ? "" : i.value))
          .join("");

        const correctOTP = debugOtp;

        const otpMsg = otpMessageContainer?.querySelector(".otp-success");

        if (hiddenInput.value !== correctOTP && otpMsg) {
          otpMsg.remove();
        }

        if (
          hiddenInput.value.length === inputs.length &&
          hiddenInput.value === correctOTP
        ) {
          showOTPMessage("verification successfully!");
        }

      });

      /* Backspace navigation */
      input.addEventListener("keydown", (e) => {
        if (e.key === "Backspace" && (!input.value || input.value === "-") && idx > 0) {
          inputs[idx - 1].focus();
        }
      });

    });

    /* ===============================
       OTP TIMER LOGIC
    =============================== */

    const otpCreated = new Date(otpCreatedAt);
    const expiryTime = new Date(otpCreated.getTime() + 5 * 60 * 1000);

    const timerElement = document.getElementById("timer");
    const countdownText = document.getElementById("countdown");

    let now = new Date();
    let timeLeft = Math.floor((expiryTime - now) / 1000);

    if (timeLeft <= 0) {
      if (countdownText)
        countdownText.innerText = "⛔ OTP expired. Please request again.";
    } else {

      let timer = setInterval(() => {

        let minutes = Math.floor(timeLeft / 60);
        let seconds = timeLeft % 60;

        if (timerElement)
          timerElement.innerText =
            `${minutes}:${seconds.toString().padStart(2, "0")}`;

        timeLeft--;

        if (timeLeft < 0) {
          clearInterval(timer);
          if (countdownText)
            countdownText.innerText = "⛔ OTP expired. Please request again.";
        }

      }, 1000);

    }

    /* ===============================
       MESSAGE AUTO HIDE
    =============================== */

    setTimeout(() => {
      document
        .querySelectorAll(".flash-message:not(.otp-success)")
        .forEach(el => {
          el.style.transition = "opacity 0.5s ease";
          el.style.opacity = "0";

          setTimeout(() => el.remove(), 500);
        });
    }, 3000);

    /* Cleanup */
    return () => {};

  }, [debugOtp, otpCreatedAt]);

  return null;
};

export default OTPBehaviour;